/* ==========================================================
   MR CART CONFIG v3.2
   ========================================================== */
window.mrCartConfig = {
  currency: 'PKR',
  milestones: [
    { id: 'shipping', label: 'Free Shipping!', threshold: 2990, icon: 'ship', enabled: true },
    { id: 'gift',     label: 'Free Gift!',     threshold: 4999, icon: 'gift', enabled: true },
    { id: 'luxury',   label: 'Free Luxury Box!', threshold: 6900, icon: 'box', enabled: false }
  ],

  /* ==============================================================
     FREE GIFT — DO TARIKE MEIN SE EK CHOOSE KARO:
       1. Variant ID directly: freeGiftVariantId: '41234567890123',
       2. Product handle:       freeGiftVariantId: 'miss-rose-free-gift',
     ⚠️ Khali hai to gift kabhi auto-add nahi hoga — pehle yeh
     confirm zaroor karein agar gift add nahi ho raha.
  ============================================================== */
  freeGiftVariantId: '48804518461657',   /* ← YAHAN DAALEN */

  /* ==============================================================
     SOCIAL PROOF — IMPORTANT
     Yeh entries real orders nahi.
     Har visitor ko yehi names/cities cycle mein dikhenge.
     Agar aapke pas real order data backend se laane ka tareeqa
     nahi hai, to is feature ko OFF rakhna zyada safe hai —
     OFF karne ke liye:
       socialProofEnabled: false
     (ya neeche array empty [] kar dein)
  ============================================================== */
  socialProofEnabled: false,   /* ← default OFF — apni marzi se true karein */
  socialProofData: [
    { city: 'Karachi',   name: 'Mano',    product: 'Miss Rose BB Cream',    mins: 0 },
    { city: 'Lahore',    name: 'Tayyaba', product: 'Miss Rose Lipstick',    mins: 0 },
    { city: 'Islamabad', name: 'Sara',    product: 'Miss Rose Foundation',  mins: 0 },
    { city: 'Peshawar',  name: 'Hina',    product: 'Miss Rose Compact',     mins: 0 },
    { city: 'Multan',    name: 'Zara',    product: 'Miss Rose Eye Shadow',  mins: 0 }
  ],
  spImageUrl: ''
};
